import { findById } from '@opengov/compose-app/immutable';
import { createSelector } from '@opengov/compose-app/reselect';

import { currentOrLegacySavedViewSelector } from '../state';
import { ICurrentOrLegacySavedView } from '@opengov/reporting-legacy-module';

export const selectCurrentOrLegacySavedViews = createSelector(
  currentOrLegacySavedViewSelector,
  (state) => state.savedViews
);

export const selectCurrentOrLegacySavedViewIdFilter = createSelector(
  selectCurrentOrLegacySavedViews,
  (savedViews) => (id) => findById(savedViews, id)
);

export const selectCurrentOrLegacySavedViewsSort = createSelector(
  selectCurrentOrLegacySavedViews,
  (savedViews) => (attribute: keyof ICurrentOrLegacySavedView) => savedViews.sortBy((sv) => sv[attribute])
);

export const selectCurrentOrLegacySavedViewsByReportIdSortedByName = createSelector(
  selectCurrentOrLegacySavedViews,
  (savedViews) => (id) => {
    return savedViews.filter((sv) => sv.reportId === id).sortBy((sv) => sv.name);
  }
);

export const areCurrentOrLegacySavedViewsLoading = createSelector(
  currentOrLegacySavedViewSelector,
  (state) => state.loadingSavedViews.active
);

export const selectCurrentOrLegacySavedViewsLoadingError = createSelector(
  currentOrLegacySavedViewSelector,
  (state) => state.loadingSavedViews.error
);
